module.exports = __webpack_public_path__ + "img/ring_r_o_1_null@2x.7906919d.png";